import { getSearchQueryAnalytics } from '@/api/searchQueryAnalytics.js';

const getDefaultFilters = () => ({
    userIds: '',
    hasSearchQuery: null,
    manualFiltersUsed: null,
    tagsUsed: null,
    customFiltersUsed: null,
    smartFiltersUsed: null,
    hqOnlyUsed: null,
});

export default {
    state: {
        analytics: [],
        isLoading: false,

        // Page-based pagination
        pagination: {
            total: 0,
            page: 1,
            perPage: 100,
        },

        // Filters
        filters: getDefaultFilters(),

        // Sorting
        sortBy: 'created_at',
        sortOrder: 'desc',
    },

    getters: {
        SEARCH_QUERY_ANALYTICS: (state) => state.analytics,
        SEARCH_QUERY_ANALYTICS_LOADING: (state) => state.isLoading,
        SEARCH_QUERY_ANALYTICS_PAGINATION: (state) => state.pagination,
        SEARCH_QUERY_ANALYTICS_FILTERS: (state) => state.filters,
        SEARCH_QUERY_ANALYTICS_CURRENT_PAGE: (state) => state.pagination.page,
    },

    mutations: {
        SET_SEARCH_QUERY_ANALYTICS(state, data) {
            state.analytics = data;
        },
        SET_SEARCH_QUERY_ANALYTICS_LOADING(state, value) {
            state.isLoading = value;
        },
        SET_SEARCH_QUERY_ANALYTICS_PAGINATION(state, { total, page, limit }) {
            state.pagination = {
                total: total || 0,
                page: page || 1,
                perPage: limit || state.pagination.perPage,
            };
        },
        SET_SEARCH_QUERY_ANALYTICS_PAGE(state, page) {
            state.pagination.page = page;
        },
        SET_SEARCH_QUERY_ANALYTICS_PER_PAGE(state, perPage) {
            state.pagination.perPage = perPage;
            state.pagination.page = 1;
        },
        SET_SEARCH_QUERY_ANALYTICS_FILTERS(state, filters) {
            state.filters = filters;
        },
        SET_SEARCH_QUERY_ANALYTICS_SORT(state, { sortBy, sortOrder }) {
            state.sortBy = sortBy;
            state.sortOrder = sortOrder;
        },
        RESET_SEARCH_QUERY_ANALYTICS_FILTERS(state) {
            state.filters = getDefaultFilters();
            state.pagination.page = 1;
        },
    },

    actions: {
        async loadSearchQueryAnalytics({ commit, state }) {
            commit('SET_SEARCH_QUERY_ANALYTICS_LOADING', true);

            try {
                const params = {
                    page: state.pagination.page,
                    limit: state.pagination.perPage,
                    sort_by: state.sortBy,
                    sort_order: state.sortOrder,
                };

                if (state.filters.userIds) {
                    params.user_ids = state.filters.userIds;
                }

                if (state.filters.hasSearchQuery !== null) {
                    params.has_search_query = state.filters.hasSearchQuery;
                }

                if (state.filters.manualFiltersUsed !== null) {
                    params.manual_filters_used = state.filters.manualFiltersUsed;
                }

                if (state.filters.tagsUsed !== null) {
                    params.tags_used = state.filters.tagsUsed;
                }

                if (state.filters.customFiltersUsed !== null) {
                    params.custom_filters_used = state.filters.customFiltersUsed;
                }

                if (state.filters.smartFiltersUsed !== null) {
                    params.smart_filters_used = state.filters.smartFiltersUsed;
                }

                if (state.filters.hqOnlyUsed !== null) {
                    params.hq_only_used = state.filters.hqOnlyUsed;
                }

                const response = await getSearchQueryAnalytics(params);

                if (response) {
                    commit('SET_SEARCH_QUERY_ANALYTICS', response.data);
                    commit('SET_SEARCH_QUERY_ANALYTICS_PAGINATION', {
                        total: response.total,
                        page: response.page,
                        limit: response.limit,
                    });
                }
            } catch (error) {
                commit('SET_SEARCH_QUERY_ANALYTICS', []);
            } finally {
                commit('SET_SEARCH_QUERY_ANALYTICS_LOADING', false);
            }
        },

        async changeSearchQueryPage({ commit, dispatch }, page) {
            commit('SET_SEARCH_QUERY_ANALYTICS_PAGE', page);
            await dispatch('loadSearchQueryAnalytics');
        },
    },
};
